<template>
  <div class="row upload_black_list_component">
    <div class="col-md-6">
      <h5>Черный список для <strong>{{ catalog.url }}</strong></h5>

      <div class="drug_search_block">
        <div class="flex">
          <div class="drug_search">
            <drugSearch
              ref="drugSearch"
              :enableQty="false"
              :onDrugSelect="drugSelected"
            />
          </div>
          <vue-ladda @click="addToBlackList" button-class="btn btn-primary fit-content" data-style="zoom-in"
                     :loading="saveListLoading">Добавить
          </vue-ladda>
        </div>
        <div>
          <div class="form-group">
            <label for="">Комментарий к препарату</label>
            <input v-model="drugData.comment" type="text" class="form-control">
          </div>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="noActualDate" v-model="noActualDate">
            <label class="form-check-label" for="noActualDate">Бессрочная запись в список</label>
          </div>
          <div class="form-group" v-if="!noActualDate">
            <label for="">Дата актуальности</label>
            <DateSelect ref="selectedDate"
                        :selectedDate="drugData.date"/>
          </div>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="toGlobalList" v-model="toGlobalList">
          <label class="form-check-label" for="toGlobalList">Добавить в глобальный черный список
          </label>
        </div>
      </div>

      <hr>

      <table class="table table-hover black_list_table">
        <thead>
        <tr>
          <th></th>
          <th>Препарат</th>
          <th>ID</th>
          <th>ЕГК</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(record, index) in sort(localList)">
          <tr>
            <td rowspan="2">{{ index + 1 }}</td>
            <td>{{ getDrugName(record) }}</td>
            <td>{{ record.drug.id }}</td>
            <td>{{ record.drug.egk }}</td>
            <td rowspan="2">
              <button @click="removeFromBlackList(record.id)" class="btn btn-xs btn-danger"><i
                class="icon-fa icon-fa-remove"></i></button>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <p v-if="record.actual_date">актуально до: <strong>{{ record.actual_date }}</strong></p>
              <div v-if="record.comments">
                <p>{{ record.comments.comment }}</p>
                <p class="text-muted text-right">{{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}
                  ({{ record.comments.user_id }}) {{ record.comments.user_name }}</p>
              </div>
            </td>
          </tr>
        </template>
        </tbody>
      </table>

    </div>
    <div class="col-md-6">
      <h5>Глобальный черный список</h5>
      <table class="table table-hover black_list_table">
        <thead>
        <tr>
          <th></th>
          <th>Препарат</th>
          <th>ID</th>
          <th>ЕГК</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(record, index) in sort(globalList)">
          <tr>
            <td rowspan="2">{{ index + 1 }}</td>
            <td>{{ getDrugName(record) }}</td>
            <td>{{ record.object_id }}</td>
            <td>{{ record.drug.egk }}</td>
            <td rowspan="2">
              <button @click="removeFromBlackList(record.id, true)" class="btn btn-xs btn-danger"><i
                class="icon-fa icon-fa-remove"></i></button>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <p v-if="record.actual_date">актуально до: <strong>{{ record.actual_date }}</strong></p>
              <p v-if="record.comments">{{ record.comments.comment }}</p>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

import api from '@/api'
// import drugSearch from '@/components/drugs/drugSearchWithData'
import drugSearch from "../drugs/drugSearch";
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import moment from 'moment'
import DateSelect from "../../views/reports/components/DateSelect";

export default {
  title: 'Выгрузки на справочные',
  components: {
    drugSearch,
    VueLadda,
    DateSelect,
  },
  computed: {
    gList: {
      get() {
        return this.globalList;
      },
      set(data) {
        this.globalList = data;
      }
    },
    localList: {
      get() {
        return this.drugs;
      },
      set(data) {
        this.drugs = data;
      }
    }
  },
  data() {
    return {
      toGlobalList: 0,
      noActualDate: 0,
      saveListLoading: false,
      drugData: {
        comment: '',
        date: moment().add(1, 'month').format('DD.MM.YYYY')
      }
    }
  },
  props: [
    'drugs', 'catalog', 'siteId', 'globalList', 'updateList'
  ],
  methods: {
    drugSelected(e) {
      this.drugData.comment = '';
    },
    sort(drugs) {
      let sorted = _.orderBy(drugs, 'drug.prep');
      return sorted;
    },
    getDrugName(record) {
      if (record.drug) return record.drug.prep;
      // if (drug.egk1) return drug.egk1.prep;
      // if (drug.egk2) return drug.egk2.prep;
    },
    async addToBlackList() {

      if (!this.drugData.comment) {
        toastr['warning']('Комментарий обязателен для добавления в список');
        return;
      }
      if (!this.noActualDate && !moment(this.$refs.selectedDate.date, 'DD.MM.YYYY', true).isValid()) {
        toastr['warning']('Дата актуальности не валидна');
        return;
      }

      let drug = this.$refs.drugSearch.drug;
      if (!drug) return;
      this.saveListLoading = true;
      let {data} = await api.post('/uploads/addToBlackList', {
        drug: drug,
        drugData: {...this.drugData, date: this.$refs.selectedDate && this.$refs.selectedDate.date},
        toGlobalList: this.toGlobalList,
        catalog_id: this.catalog.id,
        site_id: this.siteId,
      });
      if (data.success) {
        let newDrug = {
          drug: drug,
          egk: drug.egk,
          id: data.id,
          morion: drug.id,
        };
        if (this.toGlobalList)
          this.gList.push(newDrug);
        else
          this.localList.push(newDrug);

        this.$refs.drugSearch.drug = null;
        if (this.updateList) {
          this.updateList();
        }
        this.drugData = {
          comment: '',
          date: moment().add(1, 'month').format('DD.MM.YYYY')
        };
        toastr['success']('Препарат добавлен в список');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }

      this.saveListLoading = false;
    },
    async removeFromBlackList(id, global = false) {
      let {data} = await api.post('/uploads/removeFromBlackList', {
        record_id: id
      });

      if (data.success) {
        if (global)
          this.$emit('updateGlobalList', this.gList.filter(d => d.id != id));
        else {
          this.$emit('updateList', this.localList.filter(d => d.id != id));
        }
        if (this.updateList) {
          this.updateList();
        }
        toastr['success']('Препарат удален из списка');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    }
  }
}

</script>


<style>
.upload_black_list_component .drug_search_block .drug_select {
  width: 100%;
  min-width: auto;
}

.upload_black_list_component .drug_search .v-popover {
  display: none;
}

.drug_search .vs__dropdown-toggle {
  height: 39px;
  border-radius: 0;
}

.upload_black_list_component .fit-content {
  height: fit-content;
}

</style>

<style scoped>

.black_list_table td,
.black_list_table th {
  padding: 5px;
}

/*.drug_search_block .btn{*/
/*    border-radius: 0;*/
/*}*/
.drug_search_block {
  padding: 15px 0;
}

.flex .drug_search {
  width: calc(100% - 112px);
}

.flex button {
  width: 112px;
}

.black_list_table .btn i {
  width: auto;
}

table p {
  margin-bottom: 2px;
}
</style>
